import React from "react";
import CustomEmptyState from "../../ui/CustomEmptyState/CustomEmptyState";

const MerchantEmptyState = ({ isTrueEmpty, isFilteredEmpty }) => {
  if (isTrueEmpty) {
    return (
      <CustomEmptyState
        height={300}
        primary="No merchants have been created yet."
        secondary="Start by creating your first merchant to control access in your system."
      />
    );
  }

  if (isFilteredEmpty) {
    return (
      <CustomEmptyState
        height={200}
        primary="No merchants match your search."
        secondary="Try a different search term or clear your search to see all merchants."
      />
    );
  }

  return null;
};

export default MerchantEmptyState;
